import Quiz from './Quiz.gql';

export default Quiz;
